module.exports = __webpack_public_path__ + "static/media/basemap-imagery.0b7400a4.jpg";